module.exports = __webpack_public_path__ + "static/media/photo51.ca41656b.jpg";